import React, { useState } from 'react';

const AdminUsers = () => {
  const [searchFilter, setSearchFilter] = useState('');
  const [roleFilter, setRoleFilter] = useState('');
  const [page, setPage] = useState(1);

  // Dummy Data
  const users = [
    {
      _id: '1',
      firstName: 'Ali',
      lastName: 'Khan',
      email: 'ali@gmail.com',
      role: 'user',
      isActive: true,
      totalOrders: 5,
      totalSpent: 120,
      createdAt: new Date()
    },
    {
      _id: '2',
      firstName: 'Sara',
      lastName: 'Ahmed',
      email: 'sara@gmail.com',
      role: 'admin',
      isActive: false,
      totalOrders: 10,
      totalSpent: 500,
      createdAt: new Date()
    }
  ];

  const totalPages = 1;

  const updateUserStatus = (userId, isActive, role) => {
    alert(`Demo Mode: User ${userId} updated`);
  };

  // Filter Logic (frontend demo)
  const filteredUsers = users.filter((u) => {
    return (
      (u.firstName + u.lastName + u.email)
        .toLowerCase()
        .includes(searchFilter.toLowerCase()) &&
      (roleFilter ? u.role === roleFilter : true)
    );
  });

  return (
    <div className="min-h-screen bg-gradient-to-br from-purple-900 via-purple-800 to-purple-900 py-8">
      <div className="max-w-7xl mx-auto px-4">

        {/* Header */}
        <div className="mb-10">
          <h1 className="text-4xl font-bold text-white">
            Manage Users 👥
          </h1>
          <p className="text-purple-200 mt-2">
            View and manage all registered users
          </p>
        </div>

        {/* Filters */}
        <div className="bg-premium-purple-100 rounded-2xl shadow-xl p-6 mb-8 border border-purple-600">
          <div className="grid md:grid-cols-3 gap-6">

            <input
              type="text"
              value={searchFilter}
              onChange={(e) => setSearchFilter(e.target.value)}
              placeholder="Search users..."
              className="input-field"
            />

            <select
              value={roleFilter}
              onChange={(e) => setRoleFilter(e.target.value)}
              className="input-field"
            >
              <option value="">All Roles</option>
              <option value="user">User</option>
              <option value="admin">Admin</option>
            </select>

            <button className="btn-primary">
              Apply Filters
            </button>

          </div>
        </div>

        {/* Table */}
        <div className="bg-premium-purple-100 rounded-2xl shadow-xl overflow-hidden border border-purple-600">
          <table className="w-full text-sm">
            <thead className="bg-purple-800 text-white">
              <tr>
                <th className="p-4 text-left">User</th>
                <th>Email</th>
                <th>Role</th>
                <th>Status</th>
                <th>Orders</th>
                <th>Spent</th>
                <th>Joined</th>
                <th>Actions</th>
              </tr>
            </thead>

            <tbody>
              {filteredUsers.map((u) => (
                <tr key={u._id} className="border-t border-purple-700 hover:bg-purple-700 transition">
                  
                  <td className="p-4 flex items-center gap-3">
                    <div className="w-10 h-10 rounded-full bg-purple-600 text-white flex items-center justify-center font-bold">
                      {u.firstName[0]}{u.lastName[0]}
                    </div>
                    <div>
                      <p className="font-medium text-white">{u.firstName} {u.lastName}</p>
                      <p className="text-xs text-purple-300">ID: {u._id}</p>
                    </div>
                  </td>

                  <td className="text-purple-200">{u.email}</td>

                  <td>
                    <span className={`px-3 py-1 text-xs rounded-full ${
                      u.role === 'admin'
                        ? 'bg-purple-800 text-white'
                        : 'bg-green-700 text-white'
                    }`}>
                      {u.role}
                    </span>
                  </td>

                  <td>
                    <span className={`px-3 py-1 text-xs rounded-full ${
                      u.isActive
                        ? 'bg-green-700 text-white'
                        : 'bg-red-700 text-white'
                    }`}>
                      {u.isActive ? 'Active' : 'Inactive'}
                    </span>
                  </td>

                  <td className="text-white">{u.totalOrders}</td>
                  <td className="text-white">${u.totalSpent}</td>
                  <td className="text-purple-200">{new Date(u.createdAt).toLocaleDateString()}</td>

                  <td>
                    <div className="flex gap-2">

                      <select
                        value={u.isActive ? 'active' : 'inactive'}
                        onChange={(e) =>
                          updateUserStatus(u._id, e.target.value === 'active', u.role)
                        }
                        className="input-field text-xs"
                      >
                        <option value="active">Active</option>
                        <option value="inactive">Inactive</option>
                      </select>

                      <select
                        value={u.role}
                        onChange={(e) =>
                          updateUserStatus(u._id, u.isActive, e.target.value)
                        }
                        className="input-field text-xs"
                      >
                        <option value="user">User</option>
                        <option value="admin">Admin</option>
                      </select>

                    </div>
                  </td>

                </tr>
              ))}
            </tbody>
          </table>

          {filteredUsers.length === 0 && (
            <div className="text-center py-10 text-purple-200">
              No users found
            </div>
          )}
        </div>

      </div>
    </div>
  );
};

export default AdminUsers;